import {AppsyncService} from "../shared/AppsyncService";
import {oktaAuth} from "../config/OktaConfig";
import gql from "graphql-tag";
import {requestDivertFromUkUploadUrl, triggerProcessDivertFromUkFile} from "../../graphql/ds-left-cw-api/tant/mutations";

export class DivertFromUKService {

    tantAppsyncService : AppsyncService;

    constructor() {
        this.tantAppsyncService = new AppsyncService(process.env.REACT_APP_APPSYNC_TANT_ENDPOINT!, oktaAuth)
    }

    async uploadFile(file: File, onStatusUpdate: any, onCompleted: any) : Promise<any> {
        onStatusUpdate("Triggering upload of " + file.name);
        const uploadUrl = await this.tantAppsyncService.appSyncClient.mutate({
            mutation: gql(requestDivertFromUkUploadUrl),
            variables: {}
        });
        console.log("Upload url ", uploadUrl);
        const uploadUrlData = (uploadUrl.data as any).requestDivertFromUkUploadUrl;
        onStatusUpdate("Uploading " + file.name);
        await fetch(uploadUrlData.uploadUrl, {
            method: 'PUT',
            body: file,
            headers: {
              'Content-Type': file.type
            }
        });
        onStatusUpdate("Trigger processing");
        await this.tantAppsyncService.appSyncClient.mutate({
            mutation: gql(triggerProcessDivertFromUkFile),
            variables: {
                fileId: uploadUrlData.fileId
            }
        });
        onCompleted();
    }

}